var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAlibabaSite && _vm.footerInfo)?_c('div',{staticClass:"footer_box"},[_c('span',{staticStyle:{"margin-right":"12px"}},[_vm._v(_vm._s(_vm.footerInfo.systemBottomFiling))]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('key1000052') + _vm.footerInfo.domainFilingCode))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }